import { useEffect } from 'react';
import { auth } from '../Firebase/firebase';
import { useNavigate } from 'react-router-dom';
import useSessionTimeout from '../hooks/useSessionTimeout';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  
  // Check auth state
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (!user) {
        navigate('/login');
      }
    });
    
    return () => unsubscribe();
  }, [navigate]);
  
  // Apply session timeout (4 minutes)
  useSessionTimeout(15);
  
  return children;
};

export default ProtectedRoute;